export const OtherSamplesFeedbackPageInfo = () => {
    return (
        <>
            This shows examples of how to use feedback to give to the user after certain actions.<br /><br />
            Your main app component needs to be wrapped in a SisLibraryProviders context.<br />
            Use the <i>useFeedback</i> react hook.<br />
            You can change the duration of the feedback as well.<br />
            You can also use html instead of text for styling. (also as shown in the examples).
        </>
    )
}
